<template>
    <v-container fluid>
        <div class="modal-padding cp3-modal cp-3-edit-parent fix-error-message">
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="show-drop-down">
                        <div class="label-data">Edit Parent Name:</div>
                        <div class="field-data">
                            <v-text-field v-model="name" class="fix-200"></v-text-field>
                            <InputError :data='error.name' />
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="12">
                    <div class="show-drop-down">
                        <div class="label-data">Edit Email:</div>
                        <div class="field-data">
                            <v-text-field v-model="email" class="fix-200"></v-text-field>
                            <InputError :data='error.email' />
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="bottom-btn left-btn">
                        <v-btn :loading="saveLoading" @click="updateDEO(false)" class="right-btn cust-btn" color="primary">Done</v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: 'EditStudentBatchDetails',
    props: ['onClose', 'data', 'status'],
    data() {
        return {
            name: this.data ? this.data.name : '',
            email: this.data ? this.data.email : '',
            approvalLoading: false,
            saveLoading: false,
            centers: [],
    
            error: {
                name: {
                    type: null,
                    message: 'Please enter name'
                },
                email: {
                    type: null,
                    message: 'Please enter email'
                },  
        
            },

        }
    },
    methods: {
        ...mapActions({
            getCenters: "centerAndBatchStore/getCenters",
            updateExternalUser: "userStore/updateExternalUser"

        }),
        validate() {  
            this.email = this.removeWhiteSpacesFromEmail(this.email);
            let isValid = true;
            this.error.name.type = null;
            this.error.email.type = null;
            if ((!this.name) || this.name.trim().length < 1) {
                this.error.name.type = 'error';
                this.error.name.message = 'Please enter name';
                isValid = false;
            }
            if (!this.email||this.email.length<1) {

                this.error.email.type = 'error';
                this.error.email.message = 'Please enter email ID.';
                isValid = false;
            }
            else if (!this.isValidEmail(this.email)) {

                this.error.email.type = 'error';
                this.error.email.message = 'Please enter a valid email ID.';
                isValid = false;
            }
            return isValid;
        },
        
        
        
        updateDEO() {
            this.loading = true;
            if (this.validate()) {
            this.saveLoading = true;
           
           this.updateExternalUser({ user_id:this.data.id, name: this.name.trim(), email: this.email, role_id: this.roleIds.ED }).then(response => {
                        this.loading = false;
                        this.email = '',
                            this.name = '',
                        this.$toasted.success(`Parent Updated Successfully`, { icon: 'check_circle' });
                        this.saveLoading = false;

                        this.loading = false;

                        this.onClose({status: false,reload:true});

                    })
                    .catch(err => {
                        this.loading = false;
                        this.saveLoading = false;

                    });


            } else {
                this.loading = false;
            }
        }
    },
   
    watch: {
        status(val) {
            this.name = this.data ? this.data.name : null;
            this.email = this.data ? this.data.email : null;

            
        },
        name() {
            this.error.name.type = null;
        },
        email() {
            this.error.email.type = null;
        }
    }
}
</script>